import Vue from 'vue';
import ViewModelBase from '@glittr/frontend-core/src/core/v2/app/viewModelBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';

export default class RedebitDetailPage extends ViewModelBase {
  redebitDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.redebits.getRedebitById,
  });

  get redebit() {
    return this.redebitDataSource.data?.data ?? undefined;
  }

  async initialize(): Promise<void> {
    await this.redebitDataSource.select();
  }

  statusCodeToState(statusCode?: number) {
    if (statusCode === undefined) {
      return Vue.$t('page.app.redebits.list.states.1'); // Pending
    } if (statusCode >= 200 && statusCode <= 299) {
      return Vue.$t('page.app.redebits.list.states.2'); // Success
    } if (statusCode >= 400 && statusCode <= 599) {
      return Vue.$t('page.app.redebits.list.states.3'); // Error
    }
    return Vue.$t('page.app.redebits.list.states.1'); // Pending
  }

  translatePaymentState(status?: string) {
    if (status === undefined) {
      return Vue.$tEnum('page.app.redebits.paymentstatus', 'pending');
    }
    const fallback = status.charAt(0).toUpperCase() + status.slice(1);
    return Vue.$tEnum('page.app.redebits.paymentstatus', status, fallback);
  }
}
